export default function AboutSection() {
  return (
    <section id="sobre" data-cascade className="relative w-full py-28 md:py-44 paper-texture overflow-hidden">
      {/* Organic background blurs */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[10%] right-[-5%] w-[45%] h-[50%] rounded-full bg-rose-light/12 blur-[140px]" />
        <div className="absolute bottom-[5%] left-[-8%] w-[35%] h-[45%] rounded-full bg-sage-light/8 blur-[100px]" />
      </div>

      <div className="relative max-w-[1300px] mx-auto px-6 md:px-12">
        <div className="flex flex-col lg:flex-row lg:items-start gap-0">
          {/* Left: Large editorial photo */}
          <div data-cascade-image className="relative w-full lg:w-[50%] flex-shrink-0">
            <div className="relative w-full max-w-[480px] mx-auto lg:mx-0">
              {/* Organic decorative circles */}
              <div className="absolute -top-8 -left-8 w-24 h-24 rounded-full border border-gold-matte/15 opacity-60" />
              <div className="absolute -bottom-6 -right-6 w-32 h-32 rounded-full bg-rose-light/15 blur-[50px]" />

              <div className="w-full aspect-[3/4] overflow-hidden">
                <img
                  src="https://storage.helloreaddy.io/project_files/7ae9a526-920c-4103-99ac-b845e125a623/5057d62b-f986-44d5-a4b2-813984d1f764_compressed_Imagem-1-gerada-14.webp"
                  alt="Dra. Nathália Posso - Sobre"
                  title="Dra. Nathália Posso | Ginecologista em Fortaleza"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Signature overlapping photo */}
              <div className="absolute bottom-[-50px] right-[-20px] md:right-[-40px] z-10">
                <p className="font-heading text-3xl md:text-4xl text-gold-matte/50 italic whitespace-nowrap">
                  Nathália Posso
                </p>
              </div>
            </div>
          </div>

          {/* Right: Editorial text */}
          <div className="w-full lg:w-[50%] lg:pl-16 lg:pt-10 mt-20 lg:mt-0">
            <div className="flex flex-col gap-8">
              {/* Label */}
              <div>
                <p data-cascade-label className="font-body text-[10px] md:text-[11px] text-secondary-500 tracking-[0.4em] uppercase mb-4">
                  Sobre a Dra.
                </p>
                <div data-cascade-line className="w-12 h-[1px] bg-gold-matte/40 mb-8" />

                {/* Main title */}
                <h2 data-cascade-title className="font-heading text-3xl md:text-4xl lg:text-5xl text-graphite font-light leading-[1.15] mb-8 max-w-lg">
                  Uma médica que{' '}
                  <span className="italic">escuta</span>,{' '}
                  <span className="italic">acolhe</span> e{' '}
                  <span className="italic">transforma</span>.
                </h2>

                <p data-cascade-text className="font-body text-sm md:text-base text-graphite/55 leading-relaxed font-light max-w-lg">
                  A Dra. Nathália Posso acredita que a saúde íntima vai muito além do consultório.
                  Com formação sólida e atualização constante, ela oferece um atendimento
                  ginecológico que une a precisão da ciência à sensibilidade do cuidado humanizado.
                </p>
              </div>

              {/* Large editorial quote */}
              <div className="relative my-4 md:my-8 pl-8 border-l-[3px] border-gold-matte/25">
                <p className="font-heading text-xl md:text-2xl lg:text-3xl text-graphite/80 italic font-light leading-[1.4] max-w-md">
                  &ldquo;Cada mulher que chega até mim carrega uma história única. Meu compromisso
                  é oferecer o melhor da medicina com o acolhimento que toda mulher merece.&rdquo;
                </p>
              </div>

              <p className="font-body text-sm text-graphite/55 leading-relaxed font-light max-w-lg">
                Especialista em Ginecologia com foco em saúde da mulher em todas as fases da vida,
                da adolescência à menopausa, a Dra. Nathália se dedica a criar um ambiente onde
                cada paciente se sinta segura, respeitada e verdadeiramente cuidada.
              </p>

              {/* CRM + RQE */}
              <div className="flex flex-wrap items-center gap-8 pt-4">
                <div className="flex flex-col">
                  <span className="font-body text-[10px] text-secondary-500 tracking-[0.2em] uppercase">CRM</span>
                  <span className="font-heading text-xl text-graphite/70">14200</span>
                </div>
                <div className="w-[1px] h-10 bg-secondary-300/30" />
                <div className="flex flex-col">
                  <span className="font-body text-[10px] text-secondary-500 tracking-[0.2em] uppercase">RQE</span>
                  <span className="font-heading text-xl text-graphite/70">8571</span>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </section>
  );
}